import { createSelector } from 'reselect'
import getInsuranceDestinationCountriesFromCart from './getInsuranceDestinationCountriesFromCart'
import getInsuranceDestinationCountriesFromExistingOrder from './getInsuranceDestinationCountriesFromExistingOrder'

const getIsInsurnaceDomesticTrip = createSelector(
  (state: App.State) => state.geo.currentRegionName,
  (state: App.State) => getInsuranceDestinationCountriesFromCart(state),
  (state: App.State) => getInsuranceDestinationCountriesFromExistingOrder(state),
  (regionName, destCountriesFromCart, destCountriesFromOrder): boolean => {
    return destCountriesFromCart.length > 0 ?
        destCountriesFromCart.every(countryName => countryName === regionName) :
        destCountriesFromOrder.every(countryName => countryName === regionName)
  },
)

export default getIsInsurnaceDomesticTrip
